import store from "../store/index";
import { entityModule, setEntity } from "@/utils/entity-mappers";

export const setNewEntity = (entity) => {
  store.commit(`${entityModule[entity]}/${setEntity[entity]}`, { _id: "NEW" });
};
